// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { hasError } from '../../utils/formatError';
import { WALLET_RULE_KIND } from '../../constants/walletRuleKind';

/**
 * Gateway rules: a gateway's payin or payout allowance rule. Core reads the rule
 * once per create, before any wallet is chosen, and a create it refuses is
 * PAYIN_NOT_ALLOWED / PAYOUT_NOT_ALLOWED for the merchant — a gateway's minimum and
 * maximum amount, above all. The cabinet refuses one that does not compile for its
 * kind, or reads a wallet (422 `GATEWAY_RULE_INVALID: …`); a gateway links a rule
 * only on the column of its kind, and one in use keeps its kind and is not archived.
 */
export default class GatewayRulesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGatewayRules';
        this.Server = this.props.context.getState().server.publicGatewayRules;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            {
                id: 'kind',
                required: true,
                label: 'kind',
                alignRight: false,
                cell: 'Items',
                items: WALLET_RULE_KIND,
                helperText: 'gatewayRuleKind',
                displayGrid: true
            },
            // The BigText editor plus the language's help: its syntax and the
            // variables the API lists (loaded below).
            {
                id: 'rule',
                required: true,
                label: 'rule',
                alignRight: false,
                cell: 'GatewayRule',
                helperText: 'gatewayRuleRule',
                displayGrid: true
            },
            { id: 'isArchived', label: 'isArchived', alignRight: false, cell: 'Boolean', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    async componentDidMount() {
        this.loadVariables();
        await super.componentDidMount();
    }

    /**
     * The variables a rule may read, once per session, into the store, where the
     * rule editor's help reads them (DialogGatewayRuleField). `false` when they
     * could not be loaded, so the help says so and the next visit tries again.
     */
    loadVariables = async () => {
        const { context } = this.props;
        if (context.getState().gatewayRuleVariables) return;
        try {
            const result = await this.Server.variables();
            const ok = !hasError(result) && Array.isArray(result.data);
            context.update({ gatewayRuleVariables: ok ? result.data : false });
        } catch (error) {
            console.error('Gateway rule variables could not be loaded:', error);
            context.update({ gatewayRuleVariables: false });
        }
    };
}
